// TODO: non-placeholder theme colors

export const CHART_COLORS = {
    blue: '#8884d8',
    green: '#82ca9d',
    yellow: '#ffc658',
} as const;

export const ACTIVITY_TYPE_COLORS = {
    Proactive: '#10b981',
    Corrective: '#ef4444',
    Predictive: '#3b82f6',
} as const;
